<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <ModalComponent
            :name="'anular-pedido-' + id"
            title="Anular pedido"
            v-on:close="() => close(false)"
        >
            <template>
                <div class="row">
                    <div class="col-12">
                        <h3 class="font-weight-bold">Se anularan las siguientes entradas</h3>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table table-hover text-nowrap">
                                <thead>
                                    <tr>
                                        <th>Descripción</th>
                                        <th>Precio + G.G</th>
                                        <th>Código qr</th>
                                        <th>Zona</th>
                                        <th>Fila/Asiento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="entrada in pedido.entradas">
                                        <tr :key="entrada.id" v-if="!entrada.deleted_at">
                                            <td>{{ entrada.concepto }}</td>
                                            <td>{{ entrada.precio | calcular_precio_entrada(entrada) }}</td>
                                            <td>{{ entrada.qr_code }}</td>
                                            <td>{{ entrada.asiento ? entrada.asiento.zona : '' }}</td>
                                            <td>
                                                <template v-if="entrada.asiento">
                                                    {{ entrada.asiento.fila }}/{{ entrada.asiento.asiento }}
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>                            
                    </div>
                    <div class="col-12 mt-2 mb-2" v-if="pedido.metodo_pago !== 4">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="devolver_entradas_no_validadas" v-model="devolver_entradas_no_validadas"/>
                            <label for="devolver_entradas_no_validadas" class="custom-control-label pt-1">Anular solo las entradas que no estén leidas en la app de control de accesos</label>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <h1 class="font-weight-bold">¿ANULAR PEDIDO?</h1>
                    </div>
                    <div class="col-12 text-center">
                        <div v-if="pedido.modalidad == 1">
                            <template v-if="pedido.datafono_response">
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularConDatafono(false)">ANULAR</Button>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularConDatafono(true)">ANULAR SIN GG</Button>
                                <DatafonoDevolucionComponent 
                                    v-if="anular_con_datafono"
                                    :importe="importe_datafono"
                                    :pedido="pedido.datafono_response.pedido"
                                    :rts="pedido.datafono_response.identificadorRTS"
                                    :datafono_id="pedido.datafono_id"
                                    @devolucionCorrecta="anuladoConDatafono"
                                />
                            </template>
                            <template v-else>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(true)">ANULAR SIN GG</Button>
                            </template>                        
                        </div>
                        <div v-else-if="evento_pasado == false">
                            <template v-if="pedido.metodo_pago == 1 || pedido.metodo_pago == 3">
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                            </template>                 
                            <ocultar-con-password message="Para anular el pedido con gastos de gestión tienes que poner una contraseña:" v-else>
                                <template>
                                    <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                                </template>
                            </ocultar-con-password>
                            <template>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(true)">ANULAR SIN GG</Button>
                            </template>
                        </div>
                        <div v-else-if="evento_pasado == true">
                            <ocultar-con-password message="Para anular el pedido tienes que poner una contraseña:">
                                <template>
                                    <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                                    <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(true)">ANULAR SIN GG</Button>
                                </template>
                            </ocultar-con-password>
                        </div>
                        <div v-if="error" class="col-12 alert alert-danger">
                            {{ error.message }}
                            {{ error.entradas_validadas && error.entradas_validadas.length > 1 ? error.entradas_validadas.map(i => i).join(', ') : error.entradas_validadas.map(i => i).join('') }}
                        </div>
                    </div>
                    <div class="col-12 mt-2">
                        <h4 class="red">*Si el pedido tiene productos asociados también serán anulados.</h4>
                    </div>
                </div>
            </template>
        </ModalComponent>
    </ValidationObserver>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import OcultarConPassword from "@/components/backend/components/OcultarConPassword.vue";
    import DatafonoDevolucionComponent from "@/components/backend/datafono/DatafonoDevolucionComponent";

    export default {
        props: ['pedido', 'sesion_id', 'evento_pasado', 'evento_id', 'id'],
        data() {
            return {
                email: null,
                loading: false,
                checkedNames: [],
                disableButton: false,
                error: null,
                anular_con_datafono: false,
                importe_datafono: null,
                anular_sin_gastos: false,
                response_datafono: null,
                devolver_entradas_no_validadas: false
            }
        },
        methods: {
            close() {
                this.error = null;
                this.$emit('close', 'anular-' + this.id);
            },
            anularConDatafono(sin_gd) {
                this.anular_sin_gastos = sin_gd;
                this.importe_datafono = this.calcularImporte(sin_gd);
                this.anular_con_datafono = true;
            },
            anuladoConDatafono(response) {
                this.response_datafono = response;
                this.anularPedido(this.sin_gd);
            },
            anularPedido(sin_gd) {
                this.loading = true;
                const data = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    id: this.id,
                    sin_gd: sin_gd,
                    devolver_entradas_no_validadas: this.devolver_entradas_no_validadas
                };

                if(this.response_datafono) {
                    data.response_datafono = this.response_datafono;
                }

                this.disableButton = true;

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.pedido.anular'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.close();
                    this.$emit('anulada');
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$toast.error(error.response.data.message);
                        this.error = error.response.data;
                    }
                }).finally(() => this.loading = false, this.disableButton = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.anularPedido();
                }
            },
            calcularImporte(sin_gd) {
                let importe = 0;

                this.pedido.entradas.forEach(entrada => {
                    if(! entrada.deleted_at) {
                        importe = importe + parseFloat(entrada.precio);

                        if(!sin_gd && entrada.price_management && ! entrada.price_management_interno) {
                            importe = importe + parseFloat(entrada.price_management);
                        } 
                    }                             
                });

                return importe;
            }
        },
        components: {
            ModalComponent, OcultarConPassword, DatafonoDevolucionComponent
        }
    }
</script>
